// extracted by mini-css-extract-plugin
export default {"root":"OXcIq","shaderTheme":"RglGx","age":"Uxate"};